module.exports = __webpack_public_path__ + "static/img/guelph2.8d4b663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/guelph2.jpg
// module id = 91
// module chunks = 9